import { Grid } from "@chakra-ui/react"

import { FeaturedWorkCardSkeleton } from "@/components/Cards/FeaturedWorkCard"

interface LoadingArticlesProps {
  postsLength?: number
}

export default function LoadingArticles({
  postsLength = 6,
}: LoadingArticlesProps) {
  return (
    <Grid
      aria-busy="true"
      data-work-articles-loading="true"
      gap={{ base: 6, md: 6 }}
      mb={6}
      templateColumns="1fr"
    >
      {Array.from({ length: postsLength }).map((_, index) => (
        <FeaturedWorkCardSkeleton key={index} onPaper />
      ))}
    </Grid>
  )
}
